export default "__VITE_ASSET__BUuRfcnK__"